import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

import { useSetHubToken } from "./Containers/Start/services/start.actions";

import "./App.css";
import Router from "./routes";
import { useAuth } from "./Store/Auth/Auth.context";
import GlobalStyle from "./Styles/global";

const theme = createTheme({
  palette: {
    primary: {
      main: "#030096",
    },
    secondary: {
      main: "#A3AFD1",
    },
  },
});

function App() {
  const [stateAuth, dispatchAuth] = useAuth();
  const [localState, setLocalState] = useState(false);

  const { setHubToken, setHubTokenError, setHubTokenLoading } =
    useSetHubToken();

  console.log({ ...setHubTokenError });
  console.log(stateAuth);

  useEffect(() => {
    if (!localState) {
      setHubToken();
      setLocalState(true);
    }
  }, [localState, setHubToken, stateAuth.hubJWT.accessToken]);

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Router />
        <GlobalStyle />
      </div>
    </ThemeProvider>
  );
}

export default App;
